import _get from 'lodash/get';


export const getFiscalNumber = state => _get(state, 'fiscalNumber.data');
export const getVatNumber = state => _get(getFiscalNumber(state), 'vat');
export const getTaxNumber = state => _get(getFiscalNumber(state), 'tax');
export const getLoadFiscalNumberError = state => (
  _get(state, 'fiscalNumber.errors.loadFiscalNumberError')
);
export const getEditIndividualFiscalNumberError = state => (
  _get(state, 'fiscalNumber.errors.editIndividualFiscalNumberError')
);
export const getEditCorporationFiscalNumberError = state => (
  _get(state, 'fiscalNumber.errors.editCorporationFiscalNumberError')
);
